import React, { useState } from "react";
import "./ContactForm.css";
import emailjs from "emailjs-com";
import InfoColumn from "./InfoColumn";

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    requestType: "Cumparare", // Default value (can be "Cumparare", "Vânzare", or "Transport Marfa")
    locIncarcare: "",
    locDescarcare: "",
    tipMarfa: "",
    greutate: "",
    volum: "",
    tipCamion: "",
    dataIncarcare: "",
    dataDescarcare: "",
  });

  const [errors, setErrors] = useState({
    name: false,
    phone: false,
    email: false,
    message: false,
    requestType: false,
    locIncarcare: false,
    locDescarcare: false,
    tipMarfa: false,
    volum: false,
    tipCamion: false,
    dataIncarcare: false,
    dataDescarcare: false,
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validateForm = () => {
    const isTransportMarfa = formData.requestType === "Transport Marfa";
    const isCumparare = formData.requestType === "Cumparare";
    const isVanzare = formData.requestType === "Vânzare";

    const newErrors = {
      name: formData.name.trim() === "",
      phone: formData.phone.trim() === "",
      email: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()),
      message: formData.message.trim() === "",
      requestType: formData.requestType === "",
      // For Transport Marfă
      locIncarcare: isTransportMarfa ? formData.locIncarcare.trim() === "" : false,
      locDescarcare:
        isTransportMarfa || isCumparare
          ? formData.locDescarcare.trim() === ""
          : false,
      tipMarfa:
        isTransportMarfa || isCumparare || isVanzare
          ? formData.tipMarfa.trim() === ""
          : false,
      volum:
        isTransportMarfa || isCumparare || isVanzare
          ? formData.volum.trim() === ""
          : false,
      tipCamion: isTransportMarfa ? formData.tipCamion.trim() === "" : false,
      dataIncarcare:
        isTransportMarfa || isVanzare ? formData.dataIncarcare.trim() === "" : false,
      dataDescarcare:
        isTransportMarfa || isCumparare ? formData.dataDescarcare.trim() === "" : false,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form validated successfully!");

      const serviceId = "service_eo0o5ov";
      const templateId = "template_ctfkvf5";
      const userId = "v9l1icgw6iQZ7zBSZ";

      emailjs
        .send(serviceId, templateId, formData, userId)
        .then((response) => {
          console.log(
            "Form submitted successfully!",
            response.status,
            response.text
          );
          alert(
            "Mesajul dumneavoastră a fost trimis cu succes! Un reprezentant va lua legătura cu dumneavoastră în cel mai scurt timp."
          );
        })
        .catch((err) => {
          console.error("Failed to submit form...", err);
          alert(
            "Eroare! Mesajul nu a fost trimis, vă rugăm să încercați mai târziu sau să folosiți altă modalitate de contact."
          );
        });
    }
  };

  return (
    <div className="contact-form-container">
      <div className="contact-form-columns">
        <div className="form-column">
          <div className="form-column-title-section">
            <h2>Solicită o ofertă</h2>
            <p className="italic-text">
              ...și te vom contacta în cel mai scurt timp
            </p>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            {/* Dropdown for "Sunt interesat de:" */}
            <label htmlFor="requestType" className="dropdown-label">
              Sunt interesat de (alegeți o opțiune):
            </label>
            <select
              id="requestType"
              name="requestType"
              value={formData.requestType}
              onChange={handleChange}
              className={errors.requestType ? "error" : ""}
            >
              <option value="Cumparare">Cumpărare</option>
              <option value="Vânzare">Vânzare</option>
              <option value="Transport Marfa">Transport Marfă</option>
            </select>
            {errors.requestType && (
              <p className="error-message">Selectați un tip de solicitare!</p>
            )}

            {/* Conditional fields */}
            {formData.requestType === "Transport Marfa" && (
              <>
                <input
                  type="text"
                  name="locIncarcare"
                  placeholder="Loc de încărcare"
                  value={formData.locIncarcare}
                  onChange={handleChange}
                  className={errors.locIncarcare ? "error" : ""}
                />
                {errors.locIncarcare && (
                  <p className="error-message">Introduceți locul de încărcare!</p>
                )}

                <input
                  type="text"
                  name="locDescarcare"
                  placeholder="Loc de descărcare"
                  value={formData.locDescarcare}
                  onChange={handleChange}
                  className={errors.locDescarcare ? "error" : ""}
                />
                {errors.locDescarcare && (
                  <p className="error-message">
                    Introduceți locul de descărcare!
                  </p>
                )}

                <input
                  type="text"
                  name="tipMarfa"
                  placeholder="Tip marfă"
                  value={formData.tipMarfa}
                  onChange={handleChange}
                  className={errors.tipMarfa ? "error" : ""}
                />
                {errors.tipMarfa && (
                  <p className="error-message">Introduceți tipul de marfă!</p>
                )}

                <input
                  type="text"
                  name="greutate"
                  placeholder="Greutate (opțional)"
                  value={formData.greutate}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="volum"
                  placeholder="Volum"
                  value={formData.volum}
                  onChange={handleChange}
                  className={errors.volum ? "error" : ""}
                />
                {errors.volum && (
                  <p className="error-message">Introduceți volumul!</p>
                )}

                <input
                  type="text"
                  name="tipCamion"
                  placeholder="Tip camion"
                  value={formData.tipCamion}
                  onChange={handleChange}
                  className={errors.tipCamion ? "error" : ""}
                />
                {errors.tipCamion && (
                  <p className="error-message">Introduceți tipul de camion!</p>
                )}

                <input
                  type="date"
                  name="dataIncarcare"
                  placeholder="Dată încărcare"
                  value={formData.dataIncarcare}
                  onChange={handleChange}
                  className={errors.dataIncarcare ? "error" : ""}
                />
                {errors.dataIncarcare && (
                  <p className="error-message">
                    Selectați data de încărcare!
                  </p>
                )}

                <input
                  type="date"
                  name="dataDescarcare"
                  placeholder="Dată descărcare"
                  value={formData.dataDescarcare}
                  onChange={handleChange}
                  className={errors.dataDescarcare ? "error" : ""}
                />
                {errors.dataDescarcare && (
                  <p className="error-message">
                    Selectați data de descărcare!
                  </p>
                )}
              </>
            )}

            {formData.requestType === "Cumparare" && (
              <>
                <input
                  type="text"
                  name="locDescarcare"
                  placeholder="Loc de descărcare"
                  value={formData.locDescarcare}
                  onChange={handleChange}
                  className={errors.locDescarcare ? "error" : ""}
                />
                {errors.locDescarcare && (
                  <p className="error-message">
                    Introduceți locul de descărcare!
                  </p>
                )}

                <input
                  type="text"
                  name="tipMarfa"
                  placeholder="Tip marfă"
                  value={formData.tipMarfa}
                  onChange={handleChange}
                  className={errors.tipMarfa ? "error" : ""}
                />
                {errors.tipMarfa && (
                  <p className="error-message">Introduceți tipul de marfă!</p>
                )}

                <input
                  type="text"
                  name="greutate"
                  placeholder="Greutate (opțional)"
                  value={formData.greutate}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="volum"
                  placeholder="Volum"
                  value={formData.volum}
                  onChange={handleChange}
                  className={errors.volum ? "error" : ""}
                />
                {errors.volum && (
                  <p className="error-message">Introduceți volumul!</p>
                )}

                <input
                  type="date"
                  name="dataDescarcare"
                  placeholder="Dată descărcare"
                  value={formData.dataDescarcare}
                  onChange={handleChange}
                  className={errors.dataDescarcare ? "error" : ""}
                />
                {errors.dataDescarcare && (
                  <p className="error-message">
                    Selectați data de descărcare!
                  </p>
                )}
              </>
            )}

            {formData.requestType === "Vânzare" && (
              <>
                <input
                  type="text"
                  name="locIncarcare"
                  placeholder="Loc de încărcare"
                  value={formData.locIncarcare}
                  onChange={handleChange}
                  className={errors.locIncarcare ? "error" : ""}
                />
                {errors.locIncarcare && (
                  <p className="error-message">
                    Introduceți locul de încărcare!
                  </p>
                )}

                <input
                  type="text"
                  name="tipMarfa"
                  placeholder="Tip marfă"
                  value={formData.tipMarfa}
                  onChange={handleChange}
                  className={errors.tipMarfa ? "error" : ""}
                />
                {errors.tipMarfa && (
                  <p className="error-message">Introduceți tipul de marfă!</p>
                )}

                <input
                  type="text"
                  name="greutate"
                  placeholder="Greutate (opțional)"
                  value={formData.greutate}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="volum"
                  placeholder="Volum"
                  value={formData.volum}
                  onChange={handleChange}
                  className={errors.volum ? "error" : ""}
                />
                {errors.volum && (
                  <p className="error-message">Introduceți volumul!</p>
                )}

                <input
                  type="date"
                  placeholder="Dată încărcare"
                  name="dataIncarcare"
                  value={formData.dataIncarcare}
                  onChange={handleChange}
                  className={errors.dataIncarcare ? "error" : ""}
                />
                {errors.dataIncarcare && (
                  <p className="error-message">
                    Selectați data de încărcare!
                  </p>
                )}
              </>
            )}

            {/* Common Fields */}
            <input
              type="text"
              name="name"
              placeholder="Nume"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error" : ""}
            />
            {errors.name && <p className="error-message">Introduceți un nume!</p>}

            <input
              type="text"
              name="phone"
              placeholder="Număr de telefon"
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? "error" : ""}
            />
            {errors.phone && (
              <p className="error-message">Introduceți un număr de telefon!</p>
            )}

            <input
              type="email"
              name="email"
              placeholder="Adresă de Email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? "error" : ""}
            />
            {errors.email && (
              <p className="error-message">Introduceți o adresă validă de email!</p>
            )}

            <textarea
              name="message"
              placeholder="Mesajul dumneavoastră"
              value={formData.message}
              onChange={handleChange}
              className={errors.message ? "error" : ""}
            />
            {errors.message && (
              <p className="error-message">Introduceți un mesaj!</p>
            )}

            <button className="main-button" type="submit">
              TRIMITE
            </button>
          </form>
        </div>
        <InfoColumn />
      </div>
    </div>
  );
};

export default ContactForm;
